import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import dashboardIconSelected from '../../assets/navBar/dashboardIconSe.svg';
import dashboardIconUnselected from '../../assets/navBar/dashboardIconUn.svg';
import aboutIconSelected from '../../assets/navBar/aboutIconSe.svg';
import aboutIconUnselected from '../../assets/navBar/aboutIconUn.svg';
import liqIconSelected from '../../assets/navBar/liqIconSe.svg';
import liqIconUnselected from '../../assets/navBar/liqIconUn.svg';
import { useLocation } from 'react-router-dom';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

export default function MobileSwitch() {
  const location = useLocation();
  const currentPath = location.pathname.slice(1).split('/')[0] || 'dashboard';

  return (
    <Box
      sx={{
        display: { xs: 'flex', sm: 'none' },
        width: '95%',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}
    >
      <Button
        component={Link}
        to="/about"
        style={{ textDecoration: 'none', width: '47%' }}
        sx={{
          color: currentPath === 'about' ? 'rgba(4, 255, 218, 1)' : '#FFFFFF',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          minHeight: { xs: '2.5rem', sm: '3rem' },
          py: 1,
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        }}
        startIcon={
          currentPath === 'about' ? <RocketLaunchIcon sx={{ color: 'rgba(4, 255, 218, 1)' }} /> : <RocketLaunchIcon />
        }
      >
        RELEND Units
      </Button>
      <Button
        component={Link}
        to="/dashboard"
        style={{ textDecoration: 'none', width: '47%' }}
        sx={{
          color: currentPath === 'dashboard' ? 'rgba(4, 255, 218, 1)' : '#FFFFFF',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          minHeight: { xs: '2.5rem', sm: '3rem' },
          py: 1,
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        }}
        startIcon={
          <img src={currentPath === 'dashboard' ? dashboardIconSelected : dashboardIconUnselected} alt="Dashboard" />
        }
      >
        Relend Vault
      </Button>
      <Button
        component={Link}
        to="/liquid-instances"
        style={{ textDecoration: 'none', width: '47%' }}
        sx={{
          color: currentPath === 'liquid-instances' ? 'rgba(4, 255, 218, 1)' : '#FFFFFF',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          minHeight: { xs: '2.5rem', sm: '3rem' },
          py: 1,
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          marginTop: '0.5rem'
        }}
        startIcon={
          <img src={currentPath === 'liquid-instances' ? liqIconSelected : liqIconUnselected} alt="Liq. Instances" />
        }
      >
        rUSDC
      </Button>
      <Button
        component={Link}
        to="/learn"
        style={{ textDecoration: 'none', width: '47%' }}
        sx={{
          color: currentPath === 'learn' ? 'rgba(4, 255, 218, 1)' : '#FFFFFF',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          minHeight: { xs: '2.5rem', sm: '3rem' },
          py: 1,
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          marginTop: '0.5rem'
        }}
        startIcon={<img src={currentPath === 'learn' ? aboutIconSelected : aboutIconUnselected} alt="Learn" />}
      >
        Learn
      </Button>
    </Box>
  );
}
